import React, { useEffect, useState } from "react";
import { Plus, Trash2, Loader2 } from "lucide-react";
import { apiGetCoupons, apiCreateCoupon, apiDeleteCoupon } from "../../api";

const AdminCoupons = () => {
  const [list, setList] = useState([]);
  const [form, setForm] = useState({ code: "", discountPercent: 10, minSubtotal: 0 });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const load = () => apiGetCoupons().then(setList).catch(() => setList([]));
  useEffect(() => { load(); }, []);

  const create = async () => {
    setError("");
    if (!form.code.trim()) { setError("Code required"); return; }
    setSaving(true);
    try {
      await apiCreateCoupon({
        code: form.code.trim(),
        discountPercent: Number(form.discountPercent),
        minSubtotal: Number(form.minSubtotal),
        active: true,
      });
      setForm({ code: "", discountPercent: 10, minSubtotal: 0 });
      load();
    } catch (err) {
      setError(err?.response?.data?.detail || "Failed");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div>
      <h1 className="font-serif text-3xl text-neutral-900 mb-6">Coupons</h1>
      <div className="bg-white rounded-sm border border-neutral-200 p-5 mb-6">
        <div className="flex flex-wrap items-end gap-3">
          <div>
            <label className="block text-xs font-medium text-neutral-600 mb-1">Code</label>
            <input value={form.code} onChange={(e) => setForm((f) => ({ ...f, code: e.target.value }))} placeholder="SUMMER20"
              className="border border-neutral-300 rounded-sm px-3 py-2 text-sm focus:outline-none focus:border-[#6b0f1a]" />
          </div>
          <div>
            <label className="block text-xs font-medium text-neutral-600 mb-1">Discount %</label>
            <input type="number" value={form.discountPercent} onChange={(e) => setForm((f) => ({ ...f, discountPercent: e.target.value }))}
              className="w-28 border border-neutral-300 rounded-sm px-3 py-2 text-sm focus:outline-none focus:border-[#6b0f1a]" />
          </div>
          <div>
            <label className="block text-xs font-medium text-neutral-600 mb-1">Min Subtotal ₹</label>
            <input type="number" value={form.minSubtotal} onChange={(e) => setForm((f) => ({ ...f, minSubtotal: e.target.value }))}
              className="w-32 border border-neutral-300 rounded-sm px-3 py-2 text-sm focus:outline-none focus:border-[#6b0f1a]" />
          </div>
          <button onClick={create} disabled={saving} className="flex items-center gap-2 bg-[#6b0f1a] text-[#e9c977] px-4 py-2 text-sm font-medium rounded-sm hover:bg-[#560b15] disabled:opacity-60">
            {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : <Plus className="h-4 w-4" />} Add
          </button>
        </div>
        {error && <p className="text-sm text-red-600 mt-2">{error}</p>}
      </div>

      <div className="bg-white rounded-sm border border-neutral-200 overflow-hidden">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-neutral-500 bg-neutral-50 border-b border-neutral-200">
              <th className="py-3 px-4 font-medium">Code</th>
              <th className="py-3 px-4 font-medium">Discount</th>
              <th className="py-3 px-4 font-medium">Min Subtotal</th>
              <th className="py-3 px-4 font-medium">Active</th>
              <th className="py-3 px-4 font-medium text-right">Actions</th>
            </tr>
          </thead>
          <tbody>
            {list.map((c) => (
              <tr key={c.id} className="border-b border-neutral-100">
                <td className="py-3 px-4 font-semibold text-[#6b0f1a]">{c.code}</td>
                <td className="py-3 px-4">{c.discountPercent}%</td>
                <td className="py-3 px-4">₹{c.minSubtotal}</td>
                <td className="py-3 px-4">{c.active ? "Yes" : "No"}</td>
                <td className="py-3 px-4 text-right">
                  <button onClick={async () => { await apiDeleteCoupon(c.id); load(); }} className="p-1.5 hover:text-red-600"><Trash2 className="h-4 w-4" /></button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminCoupons;
